module.exports = __webpack_public_path__ + "static/media/Museum_main.575847af.jpg";